<template> 

  <div class="container pt-4 mb-5">

    <b-button variant="light" :to="('/app/bg-ai/')">
      <span class="material-symbols-outlined align-middle">chevron_left</span>
      Wróć
    </b-button>
 
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz tytuł darmowego ebooka, który wyślesz po podaniu emaila:</label>

              <b-input-group>

                <b-form-input v-model="tytul_ebook" size="lg" ref="tytul_ebook" placeholder="np. 21 pytań i odpowiedzi nt. diety keto"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Opisz w kilku zdaniach kim jest Twój idealny klient:</label>

              <b-input-group>

                <b-form-input v-model="klient" size="lg" ref="klient" placeholder="np. mężczyzna w wieku 40 lat, który ma problem z wypadającymi włosami"></b-form-input>
                
              </b-input-group>
 
            </div>

            <div class="mt-3">

              <label>Jakie problemy pomożesz rozwiązać w poszczególnych emailach :</label>

              <b-input-group>

                <b-form-input v-model="problem" size="lg" ref="problem" placeholder="np. otyłość, brak energii, ciasne i małe mieszkanie"></b-form-input>

              </b-input-group>

            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje treść <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  export default {
    name: 'apxc',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        klient: "",
        tytul_ebook: "",
        problem: "",
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {

      generateFinish: function() {

        if(!this.klient) return false;
        if(!this.problem) return false;
        if(!this.tytul_ebook) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Napisz treść welcome email w stylu Dana S. Kennedyego i Russella Brunsona – bezpośredni, angażujący i nastawiony na budowanie relacji. Odbiorcami emaila są " + this.klient + "\n" +
            "Rozpocznij mocnym otwarciem, dziękując za zapis i podkreślając, że odbiorca właśnie zrobił pierwszy krok w kierunku rozwiązania problemu " + this.problem + "\n" +
            "Wpleć storytelling, aby zbudować zaufanie i podkreślić, dlaczego warto zostać subskrybentem.\n" +
            "Poinformuj o darmowym e-booku pt. " + this.tytul_ebook + " i dodaj konkretny link do jego pobrania (np. Kliknij tutaj, aby pobrać swój e-book).\n" +
            "Zakończ, wskazując, co czeka na odbiorcę w kolejnych e-mailach (np. praktyczne wskazówki, sekrety sukcesu, treści, które nie znajdą nigdzie indziej).\n" +
            "Dodaj wezwanie do działania, aby odbiorca od razu zaangażował się w Twoją markę (np. Odpowiedz na tego maila i powiedz, jaki masz największy problem z…).\n" +
            "Styl ma być konkretny, inspirujący, z elementami sprzedażowej perswazji i nutą osobowości nadawcy.\n";

        query = query + "Używaj znaczników HTML zamiast markdown. Dozwolone znaczniki: Pogrubienie czyli <B></B>, i nowa linia <br/> . Zamiast znaczników nagłówków Hx użyj po prostu pogrubienia.";

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

    },
    mounted() {

      if (localStorage.bgai_problem) {
        this.problem = localStorage.bgai_problem;
      }

      if (localStorage.bgai_klient) {
        this.klient = localStorage.bgai_klient;
      }

      if (localStorage.bgai_tytul_ebook) {
        this.tytul_ebook = localStorage.bgai_tytul_ebook;
      }

    },
    watch: {

      problem(data) {
        localStorage.bgai_problem = data;
      },

      klient(data) {
        localStorage.bgai_klient = data;
      },

      tytul_ebook(data) {
        localStorage.bgai_tytul_ebook = data;
      }

    }


  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>